const TASK_POLL_INTERVAL = 5000
const TASK_FINISHED_STATUSES = [
  'completed',
  'failed',
  'cancelled',
  'cancel',
  'timeout',
]
const TASK_FAILED_STATUSES = ['failed', 'cancelled', 'cancel', 'timeout']

let timer = null
let polling = false
const sources = new Map()

function readOwnTaskId(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return null
  }
  const hasTaskId = Object.prototype.hasOwnProperty.call(payload, 'task_id')
  const hasTaskIdCamel = Object.prototype.hasOwnProperty.call(payload, 'taskId')
  if (!hasTaskId && !hasTaskIdCamel) return null

  const raw = hasTaskId ? payload.task_id : payload.taskId
  if (raw == null || raw === '' || typeof raw === 'object') return null
  return raw
}

export function extractTaskId(res) {
  if (!res || typeof res !== 'object') return null

  const body = res.data
  const inner = body && typeof body === 'object' ? body.data : null

  return readOwnTaskId(inner) || readOwnTaskId(body)
}

export function getTaskList(res) {
  const body = (res && res.data) || res
  if (Array.isArray(body)) return body
  if (Array.isArray(body && body.data)) return body.data
  if (Array.isArray(body && body.list)) return body.list
  if (body && body.data && Array.isArray(body.data.data)) return body.data.data
  if (body && body.data && Array.isArray(body.data.list)) return body.data.list
  return []
}

export function isTaskFinished(status) {
  return TASK_FINISHED_STATUSES.includes(String(status || '').toLowerCase())
}

export function isTaskFailed(status) {
  return TASK_FAILED_STATUSES.includes(String(status || '').toLowerCase())
}

export function getTaskStatusMessage(task) {
  if (!task) return 'Đang xử lý...'
  if (task.result && task.result.message) return task.result.message
  const messages = {
    created: 'Đã tạo tiến trình',
    processing: 'Đang xử lý...',
    pending: 'Đang xử lý...',
    completed: 'Hoàn thành',
    failed: 'Thất bại',
    cancelled: 'Đã huỷ',
    cancel: 'Đã huỷ',
    timeout: 'Hết thời gian',
  }
  return messages[String(task.status || '').toLowerCase()] || 'Đang xử lý...'
}

export function applyTaskToUploadItem(item, task) {
  const next = {
    ...item,
    task,
    statusMessage: getTaskStatusMessage(task),
  }

  if (isTaskFinished(task.status)) {
    next.isDone = true
    next.isProcessing = false
    if (isTaskFailed(task.status)) {
      next.isError = true
      next.error_message = task.error || next.statusMessage || 'Xử lý thất bại'
    }
  }

  return next
}

export function registerTaskSource(key, { getItems, onUpdate }) {
  sources.set(key, { getItems, onUpdate })
  ensurePolling()
}

export function unregisterTaskSource(key) {
  sources.delete(key)
  if (!collectPending().length) {
    stopPolling()
  }
}

function collectPending() {
  const pending = []
  sources.forEach((source) => {
    const items = source.getItems() || []
    items.forEach((item) => {
      if (item && item.task_id && !item.isDone) {
        pending.push({ item, source })
      }
    })
  })
  return pending
}

function ensurePolling() {
  if (timer) {
    pollTasks()
    return
  }
  timer = setInterval(pollTasks, TASK_POLL_INTERVAL)
  pollTasks()
}

function stopPolling() {
  if (!timer) return
  clearInterval(timer)
  timer = null
}

function getSdk() {
  const mod = require('@service/auth-sdk')
  return mod && (mod.default || mod)
}

async function pollTasks() {
  if (polling) return
  const pending = collectPending()
  if (!pending.length) {
    stopPolling()
    return
  }

  const sdk = getSdk()
  if (!sdk || typeof sdk.request !== 'function') {
    return
  }

  polling = true
  const ids = [...new Set(pending.map(({ item }) => item.task_id))]

  try {
    const res = await sdk.request(
      {
        url: 'tasks',
        params: { ids, paginate: false },
      },
      { skipLoadingBar: true }
    )
    const tasks = getTaskList(res)
    const taskById = {}
    tasks.forEach((task) => {
      if (task && task.id != null) {
        taskById[String(task.id)] = task
      }
    })

    const grouped = new Map()
    pending.forEach(({ item, source }) => {
      const task = taskById[String(item.task_id)]
      if (!task) return
      if (!grouped.has(source)) grouped.set(source, [])
      grouped.get(source).push({ item, task })
    })

    grouped.forEach((updates, source) => {
      source.onUpdate(updates)
    })
  } catch (error) {
    console.error(error)
  } finally {
    polling = false
    if (!collectPending().length) {
      stopPolling()
    }
  }
}
